/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".assign-user-modal .mat-dialog-content{min-height:250px}.assign-user-modal .mat-dialog-content .roles-label{font-size:12px;margin-bottom:7px}.assign-user-modal .mat-dialog-content ui-card-info .ui-card-info-content{display:flex;justify-content:space-between;align-items:center;width:100%}.assign-user-modal .mat-dialog-content ui-card-info .ui-card-info-content button{margin-left:1em}"];
export { styles as styles };
